import {React} from 'common'
import RawTooltip from '@mui/material/Tooltip'

const Tooltip = ({title, children, ...p}) => {
    return (
        <RawTooltip title={title} {...p}>
            {children}
        </RawTooltip>
    )
}

export default Tooltip
